export default () => {
  const R = Math.floor((Math.random() * 127) + 127);
  const G = Math.floor((Math.random() * 127) + 127);
  const B = Math.floor((Math.random() * 127) + 127);

  const rgb = (R << 16) + (G << 8) + B; // eslint-disable-line no-bitwise
  return `#${rgb.toString(16)}`;
};
